const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorsetreats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "horsetreats") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.62,
    width: 997.8,
    height: 997.8,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "treats"
  }, /*#__PURE__*/React.createElement("g", {
    id: "treat-bag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.19,210.58A2639.93,2639.93,0,0,1,163,566.35q-2.49,51.38-6.8,100.46A752.62,752.62,0,0,1,139,587.71C124,495.6,129.8,422.4,135.26,358.12A1333.09,1333.09,0,0,1,156.19,210.58Z",
    style: {
      fill: "#1aadff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.27,210.58V666.81H156.19a345.08,345.08,0,0,0,14.65-39.76c24-80.1,10.56-142.71,0-227.07-5.55-44.29-12.09-108.75-14.65-189.4Z",
    style: {
      fill: "#1aadff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.87,210.58a728.51,728.51,0,0,0,.35,88.24c6.32,97.73,28.77,136.52,32.09,203,1.82,36.37-1.77,87.48-26.47,150.49a22.8,22.8,0,0,1-21.21,14.49H156.19a345.08,345.08,0,0,0,14.65-39.76c24-80.1,10.56-142.71,0-227.07-5.55-44.29-12.09-108.75-14.65-189.4Z",
    style: {
      fill: "#61deff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.19,172.91H499.87a10,10,0,0,1,10,10v27.67a0,0,0,0,1,0,0H156.19a0,0,0,0,1,0,0V182.91A10,10,0,0,1,166.19,172.91Z",
    style: {
      fill: "#8deaff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.84,627.05a345.08,345.08,0,0,1-14.65,39.76A1175.3,1175.3,0,0,0,158.8,536c-2.06-58.14-7.42-87.56-10.46-130.28-3.3-46.37-4.18-112.64,7.85-195.15.74,24.62,2.36,62.31,6.2,108.34,2.65,31.73,5.67,58.91,8.45,81.06C181.4,484.34,194.84,547,170.84,627.05Z",
    style: {
      fill: "#0096ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "label",
    d: "M459.92,326.73a23.14,23.14,0,0,1,23,20.81c.92,9.2,2.27,19.82,4.25,31.51,5.16,30.41,10.12,41.34,14.65,68.36,4.61,27.48,4.91,48.56,5.08,65,.48,46.17-8.77,71-20.89,96-2.7,5.57-9.33,9.24-16.73,9.24H228.42a16.71,16.71,0,0,1-15.64-22.54c.34-.92.68-1.86,1-2.82,8.54-24.71,8.43-46,7.62-65.33a729.11,729.11,0,0,0-7.62-79.45,1013.44,1013.44,0,0,1-10.61-100.83A18.84,18.84,0,0,1,222,326.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "chunks"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.45,574a35,35,0,0,1-30.7,15.18l-25.67-1.35a35,35,0,0,1-25.55-13.13l-17-21.37a35,35,0,0,1-5.64-33.48l9.37-26.57a35.06,35.06,0,0,1,14.37-18l4.63-2.92-.24.44-11.15,21.14a35.08,35.08,0,0,0-3.45,22.76l5.17,27.69a35,35,0,0,0,21.63,26.17l25.44,10a35,35,0,0,0,28.69-1.4Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,535.47l-19.82,35.69a31.71,31.71,0,0,1-1.73,2.79l-10.14,5.17a35,35,0,0,1-28.69,1.4l-25.44-10a35,35,0,0,1-21.63-26.17l-5.17-27.69a35.08,35.08,0,0,1,3.45-22.76L269,472.77l.24-.44,15.59-9.81a35,35,0,0,1,38.87,1l15.85,11.19a36.12,36.12,0,0,1,3,2.39l17.08,15.11A35,35,0,0,1,367,535.47Z",
    style: {
      fill: "#bfa588"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.91,521.39a36.81,36.81,0,0,1-46.24-23.68l-6.53-20.12a36.8,36.8,0,0,1,13.37-41.17l15.89-11.53a36.51,36.51,0,0,1,15.5-6.52,36.77,36.77,0,0,0-20.62,21.68l-8.1,22.77a36.83,36.83,0,0,0,12.2,41.48l15.55,12A36.18,36.18,0,0,0,432.91,521.39Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.65,485.07l-4.76,9.69a36.81,36.81,0,0,1-21.73,18.8L433,521.36l-.09,0a36.18,36.18,0,0,1-9-5.1l-15.55-12a36.83,36.83,0,0,1-12.2-41.48l8.1-22.77a36.77,36.77,0,0,1,20.62-21.68,36.79,36.79,0,0,1,27.72,6.47L472.2,439A36.81,36.81,0,0,1,483.65,485.07Z",
    style: {
      fill: "#bfa588"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,447l-15.12-2.62a32.69,32.69,0,0,1-26.35-39.21l6.06-27.69a32.55,32.55,0,0,1,10-17.22A32.46,32.46,0,0,0,296,381.93l4.69,37.19A32.69,32.69,0,0,0,326.25,447Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,385.58v31.76A32.7,32.7,0,0,1,341,449.56l-12.24-2.12-2.54-.44a32.69,32.69,0,0,1-25.59-27.88L296,381.93a32.46,32.46,0,0,1,4.85-21.67h0a32.62,32.62,0,0,1,23.45-8.43l23.83,1.09A32.71,32.71,0,0,1,379.31,385.58Z",
    style: {
      fill: "#bfa588"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 261.15,
    width: 271.02,
    height: 32.79,
    rx: 15.67,
    style: {
      fill: "#0071bc"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "apple"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.9,454c5.86.19,14.66,5.42,31.93,3.64,25.68-2.66,60.34-30.45,79.33-65.94,58.73-109.78,18.41-179.12-20-194.83s-68.78,2.16-93.08,2.16-54.68-17.88-93.08-2.16-78.72,85.05-20,194.83c20,37.29,48.28,59,84.31,65.53C715.46,459.65,726.19,453.79,732.9,454Z",
    style: {
      fill: "#ff7b82",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.26,449.73c-8.17,4.4-16.14,7.17-23.42,7.92-17.27,1.8-26.08-3.45-32-3.64-6.7-.21-17.42,5.63-30.55,3.25C666.33,450.7,638,429,618,391.73c-53.57-100.12-24.74-166.6,9.88-189.45a255.93,255.93,0,0,0-13.28,52.66c-2.75,20.41-12.49,92.76,37.71,146.66C698,450.56,762.45,451.47,788.26,449.73Z",
    style: {
      fill: "#ef5e6c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.84,237.41c-26-.7-42.23-23.42,0-23.76C761.22,213.33,757,238.35,721.84,237.41Z",
    style: {
      fill: "#ef5e6c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.84,221a24,24,0,0,1-3.27,6.8c-.41.54-1,1.26-1.76,1.21-3.7-.26.38-19.86-8.81-35.83-7.84-13.62-19.31-14.46-20-24.93A16.36,16.36,0,0,1,698.59,157a15.69,15.69,0,0,0-.35,4.41c.7,10.47,12.17,11.32,20,24.93,9.19,16,5.11,35.57,8.83,35.84C727.81,222.25,728.41,221.55,728.84,221Z",
    style: {
      fill: "#754c24",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.86,221a0,0,0,0,0,0,0v0c-.43.54-1,1.24-1.76,1.2-3.72-.27.36-19.86-8.83-35.84-7.84-13.61-19.31-14.46-20-24.93a15.69,15.69,0,0,1,.35-4.41,7.19,7.19,0,0,1,3.73-2.48c8.55-2,20.94,18.9,25.84,35.78C732.11,204,731,214.35,728.86,221Z",
    style: {
      fill: "#8c6239",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.92,276.36c-9.27,6.76-24.11,2.3-33-9.93s-8.65-27.72.62-34.48,24.11-2.31,33,9.92S854.19,269.59,844.92,276.36Z",
    style: {
      fill: "#f9bbc6",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M536.7,736.14c111.08-7.52,230.08-18.3,226.87-129.58,0,0,12.87,26.25,11.1,37.58,43.43-33.75,24.23-60.91,16.51-87.38,0,0,37.08,24.7,33.07,58.36,42.29-47.41,5.37-81.7-23.09-95.42,47.06,14.87,64.16,43.5,70,54.18,5.69,10.36,27.79-12.22,47.62-52.78-14.6,28.85-23,71.7-56.9,78.23l53.87-1.9c-13.78,18.39-81.8,19.39-90.66,38,27.19.48,73.44-8,87.66-10.33-34.61,11.94-65,20.84-110.18,36.44,15.16,7.18,29.31,8.18,58.57,1.41-153.7,53.87-207.63,99.93-324.47,73.23Z",
    style: {
      fill: "#217821"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.38,740.79C632.7,721.19,722.27,697.46,732,586.4c0,0,6.71,24.88,4.17,36.42,35.93-38.51,24.61-63.61,21.76-89.27,0,0,24.85,20.7,18.21,54.83,36.57-52.06,12.88-82.38-6.77-93,33.33,9.78,42.92,36.58,46.12,46.63a4,4,0,0,0,1.44,1.92c7.3,5.5,30.8-15.75,31.49-14.94.48.57-10.52,11-42.58,39.5L846,560.71c-12.23,19.91-62.86,28.3-71.46,47.87,20.14-2.48,55.41-16,66.23-19.87-27,15.72-50.55,27.92-85.8,48.46,10.48,5.54,20.88,5,43.35-5a1115,1115,0,0,0-97.19,59.17c-20.53,14-27.48,19.78-40.84,26.87C621.27,739,581.18,742.39,549.38,740.79Z",
    style: {
      fill: "#217821"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.56,769c95.15,11.48,149.93-115.87,257.82-102.56a.63.63,0,0,0,.36-1.18c-6.16-3.13-20-9.7-29.18-10.77a.63.63,0,0,1-.22-1.17c43.53-23.84,65-8.66,88.32.15a.63.63,0,0,0,.76-.91c-3.82-6.37-16.46-27.07-45-28.89a.63.63,0,0,1-.18-1.22c52.61-19.61,76.47,3.9,84.33,24.34a.63.63,0,0,0,1.21-.32c-3.77-30.89-25.53-45.14-34.07-50.31-8.76-5.3,20-17.79,66-26.37-31,6.09-72.94,6.71-91,25.88a.62.62,0,0,1-1-.69L861,563.39a.63.63,0,0,0-.81-.85C839,571.1,819.67,614.87,799.52,620a.63.63,0,0,1-.77-.82c6.3-16,21.89-39.82,30.41-52.64a.63.63,0,0,0-1-.76c-19.19,20.3-35.85,39.26-61.41,66a.63.63,0,0,1-1.07-.29c-2.11-9.47,0-18.16,9.8-32.4.12-.18-.44-.62-1-.78-5.66-1.69-20.51,33.45-22.12,37.08C742.5,657.6,695.58,696.45,548.56,769Z",
    style: {
      fill: "#00960e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,894.43c21.87-7.64,33.87-21,46.08-34.33,25.43-19.68,54-35.36,90.74-40.52,38.51-25.85,53.4-52,129.24-77.36a322,322,0,0,1,81.26-44.65c31.54-11.82,77.61,5.53,86.59,32.45.73,2.2,3.89,12.5-2.75,29.91-19.08,50-84.09,67-98.13,70.33-5.74,1.65-46.27,13.28-68.4,17.28-3.24.59-6.06,1.06-8.54,1.45-34.76,5.53-44.37,2.64-58.94,4.51a89.16,89.16,0,0,0-18.12,4.19c-8.28,2.79-10.43,4.81-16.69,7.48-12.42,5.31-17.42,3.12-38.21,7a224.69,224.69,0,0,0-23,5.58c-9.35,4.72-29.4,14.45-46.48,19.09-9.71,2.65-16.33,4.51-22.09,5.46a144.23,144.23,0,0,1-19.12,1.87l-12.88-2.24A3.88,3.88,0,0,1,214.45,894.43Z",
    style: {
      fill: "#fb9a33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.42,725.27l18.82,13.4C530.35,729.82,524.37,722.28,512.42,725.27Z",
    style: {
      fill: "#fff",
      opacity: 0.358900010585785,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.45,795.36l-1.78,26.84C565.93,811.47,570.71,800.92,562.45,795.36Z",
    style: {
      fill: "#fff",
      opacity: 0.358900010585785,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.39,728.49,604,739q2.12,7.07,4.22,14.14C607.9,741.19,607.28,729.63,597.39,728.49Z",
    style: {
      fill: "#fff",
      opacity: 0.358900010585785,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.86,822.33l6.61,8.73c2.39,3.16,7.35-.32,5-3.54-1.63-2.29-5.08-4.13-11.65-5.19Z",
    style: {
      fill: "#fff",
      opacity: 0.358900010585785,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.67,812l6.58,21.22C496.76,825.77,500.58,818.33,485.67,812Z",
    style: {
      fill: "#fff",
      opacity: 0.358900010585785,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.2,776.61l11.1,12.54C445.39,779.81,446,771,433.2,776.61Z",
    style: {
      fill: "#fff",
      opacity: 0.358900010585785,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,858.32l11.87,11.13C278.9,864.17,279,859,266.5,858.32Z",
    style: {
      fill: "#fff",
      opacity: 0.358900010585785,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorsetreats);
export default __webpack_public_path__ + "static/media/horsetreats.86487b43d507f81d398197b74349ff93.svg";
export { ForwardRef as ReactComponent };